import { getDefaultErrorStringForXhr } from 'zoomforth_tools/error_messaging.js';

(function() {

  zfrespond.models.ExposedCollector = Backbone.Model.extend({

    initialize: function() {
      this.listenTo(this, 'error', function(model, xhr, opts) {
        alert(getDefaultErrorStringForXhr(xhr));
      });
    },
    
    hasWelcomeVideo: function() {
      var hasVideo = false;
      if (this.get('welcome_video_details')) {
        hasVideo = true;
      }
      return hasVideo;
    },
    
    getRespondPageUrl: function() {
      return 'https://' + window.location.hostname + '/questions/' + this.get('obfuscated_id');
    },
    
    // This is substantially similar to a function on the page content item model
    // but it must be so, since lens content objects don't have asset models. Alas and alack. 
    getEmbeddedVideoParams: function($container, autoplay) {
      return {
        container: $container,
        mpeg4Source: this.get('welcome_video_details').mpeg4,
        mpeg4LowQualitySource: this.get('welcome_video_details').lowQuality,
        subtitleTrack: this.get('subtitles'),
        posterImage: this.get('welcome_video_details').poster_image,
        autoplay: autoplay
      };
    }

  });


}());